module.exports = require('./helpers/bundle-url').getBundleURL('f05n0') + "logo.c51670a8.svg";